module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-08.a0bb4dfc.jpg";